import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { elementOrDescendentHasFocus, isKeyboardEvent, tabbingOutsideOfElement } from '@chegg-ui/utils';
export function useTooltipBehavior(targetElement, open, onTooltipShown) {
  var wrapperRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTooltipShown = _useState2[0],
      setIsTooltipShown = _useState2[1]; // not a uuid, a random number to be used as id in HTML for aria purposes


  var _useState3 = useState(Number(Math.random()).toString(32)),
      _useState4 = _slicedToArray(_useState3, 1),
      id = _useState4[0];

  var showTooltip = function showTooltip() {
    return setIsTooltipShown(true);
  }; // event can either be a React synthetic event (from user interaction) or a "real" event (from the onclick listeners)


  var hideTooltip = function hideTooltip(e) {
    if (isKeyboardEvent(e)) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        setIsTooltipShown(false);
      }

      if (wrapperRef.current && tabbingOutsideOfElement(e, wrapperRef.current)) {
        setIsTooltipShown(false);
      }
    } else {
      setIsTooltipShown(false);

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    }
  };

  var givenOnMouseOver = targetElement.props.onMouseOver;
  var givenOnFocus = targetElement.props.onFocus;
  var givenOnBlur = targetElement.props.onBlur;
  useEffect(function () {
    if (isTooltipShown) {
      if (onTooltipShown) onTooltipShown();
      document.addEventListener('click', hideTooltip);
      document.addEventListener('keydown', hideTooltip);
    }

    return function () {
      document.removeEventListener('click', hideTooltip);
      document.removeEventListener('keydown', hideTooltip);
    };
  }, [isTooltipShown]);

  if (typeof open === 'boolean') {
    var _extendedTargetElement = /*#__PURE__*/React.cloneElement(targetElement, _defineProperty({}, 'aria-describedby', id));

    if (open && onTooltipShown) onTooltipShown();
    return {
      extendedTargetElement: _extendedTargetElement,
      id: id,
      isTooltipShown: open,
      wrapperRef: wrapperRef
    };
  }

  var extendedTargetElement = /*#__PURE__*/React.cloneElement(targetElement, _defineProperty({
    onMouseOver: function onMouseOver(e) {
      if (givenOnMouseOver) {
        givenOnMouseOver(e);
      }

      showTooltip();
    },
    onFocus: function onFocus(e) {
      if (givenOnFocus) {
        givenOnFocus(e);
      }

      showTooltip();
    },
    onBlur: function onBlur(e) {
      if (givenOnBlur) {
        givenOnBlur(e);
      }

      setTimeout(function () {
        // we don't want to hide the tooltip immediately if it has keyboard focus

        /* istanbul ignore next */
        if (wrapperRef.current && !elementOrDescendentHasFocus(wrapperRef.current) && isTooltipShown) {
          hideTooltip(e);
        }
      });
    }
  }, 'aria-describedby', id));

  var onMouseLeaveWrapper = function onMouseLeaveWrapper(e) {
    // we don't want to hide the tooltip immediately if it has keyboard focus
    if (wrapperRef.current && !elementOrDescendentHasFocus(wrapperRef.current)) {
      hideTooltip(e);
    }
  };

  return {
    isTooltipShown: isTooltipShown,
    extendedTargetElement: extendedTargetElement,
    onMouseLeaveWrapper: onMouseLeaveWrapper,
    id: id,
    wrapperRef: wrapperRef
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/tooltip/dist/esm/shared.js
// module id = 892
// module chunks = 11